import { useEffect, useState } from "react";
import { isAndroid, isIOS, isSafari } from "react-device-detect";

export const useWebViewDetection = () => {
  const [isWebView, setIsWebView] = useState(false);
  const [platform, setPlatform] = useState<string | null>(null);
  const uaStatic = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const isGoogleApp = /GSA\//i.test(uaStatic) || /googlequicksearchbox/i.test(uaStatic);

  useEffect(() => {
    const detectWebView = () => {
      if (typeof window === 'undefined') return;

      if (process.env.NODE_ENV === 'development' && (window as any).__FORCE_WEBVIEW__) {
        setIsWebView(true);
        setPlatform((window as any).__FORCE_WEBVIEW__ === 'ios' ? "ios" : "android");
        return;
      }

      if (window.AndroidInterface || window.webkit?.messageHandlers || window.ReactNativeWebView) {
        setIsWebView(true);
        setPlatform(window.AndroidInterface ? "android" : isIOS ? "ios" : "unknown");
        return;
      }

      const userAgent = navigator.userAgent;
      const ua = userAgent || "";
      
      const isGoogleAppUA = /GSA\//i.test(ua) || /googlequicksearchbox/i.test(ua);
      const hasWV = /;\s*wv;?/i.test(ua) || ua.includes("wv");
      const hasVersionToken = /Version\//i.test(ua);

      if (isAndroid) {
        const hasChrome = typeof window.chrome !== "undefined";

        if (!hasChrome || hasVersionToken || hasWV || isGoogleAppUA) {
          setIsWebView(true);
          setPlatform("android");
          return;
        }
      }

      if (isIOS) {
        if (isGoogleAppUA || (!isSafari && !ua.includes("CriOS"))) {
          setIsWebView(true);
          setPlatform("ios");
          return;
        }
      }

      setIsWebView(false);
      setPlatform("browser");
    };

    detectWebView();
  }, []);

  return {
    isWebView,
    platform,
    isAndroidWebView: isWebView && platform === "android",
    isIOSWebView: isWebView && platform === "ios",
    isGoogleApp,
  };
};
